import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
	TSwissPostStore,
	TSwissPostConnectedEmsResponsePayload,
	TSwissPostConnectedEmsRequestPayload,
	TSwissPostAvailableEmsResponsePayload,
	TSwissPostCreateRequestPayload,
} from './types';
// ==========================================:
export const initialState: TSwissPostStore = {
	swissPostConnectedEms: null,
	swissPostConnectedEmsLoader: false,
	swissPostAvailableEms: null,
	swissPostAvailableEmsLoader: false,
	swissPostCreateLoader: false,
};

// ==========================================:
const swissPost = createSlice({
	name: '@@swissPost',
	initialState,
	reducers: {
		getSwissPostConnectedEmsRequest: (
			state: TSwissPostStore,
			action: PayloadAction<TSwissPostConnectedEmsRequestPayload>,
		) => {
			const swissPostState = state;
			swissPostState.swissPostConnectedEmsLoader = true;
		},
		getSwissPostConnectedEmsSuccess: (
			state: TSwissPostStore,
			action: PayloadAction<TSwissPostConnectedEmsResponsePayload>,
		) => {
			const { payload } = action;
			const swissPostState = state;
			swissPostState.swissPostConnectedEms = payload;
			swissPostState.swissPostConnectedEmsLoader = false;
		},
		getSwissPostAvailableEmsRequest: (state: TSwissPostStore) => {
			const swissPostState = state;
			swissPostState.swissPostAvailableEmsLoader = true;
		},
		getSwissPostAvailableEmsSuccess: (
			state: TSwissPostStore,
			action: PayloadAction<TSwissPostAvailableEmsResponsePayload>,
		) => {
			const { payload } = action;
			const swissPostState = state;
			swissPostState.swissPostAvailableEms = payload;
			swissPostState.swissPostAvailableEmsLoader = false;
		},
		createSwissPostRequest: (
			state: TSwissPostStore,
			action: PayloadAction<TSwissPostCreateRequestPayload>,
		) => {
			const swissPostState = state;
			swissPostState.swissPostCreateLoader = true;
		},
		createSwissPostSuccess: (state: TSwissPostStore) => {
			const swissPostState = state;
			swissPostState.swissPostCreateLoader = false;
		},

		swissPostInitState: () => initialState,
	},
});

export default swissPost.reducer;
export const {
	getSwissPostConnectedEmsRequest,
	getSwissPostConnectedEmsSuccess,
	getSwissPostAvailableEmsRequest,
	getSwissPostAvailableEmsSuccess,
	createSwissPostRequest,
	createSwissPostSuccess,
	swissPostInitState,
} = swissPost.actions;
